import {
  Box,
  Button,
  Checkbox,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  VStack,
  Wrap,
} from "@chakra-ui/react";
import { FaFilter } from "react-icons/fa";

export default function Filters({ filters, setFilters, fetchOrders, resetPage }) {
  const handleStatusChange = (status) => {
    const current = filters.orderstatus || [];
    const updated = current.includes(status)
      ? current.filter((s) => s !== status)
      : [...current, status];

    setFilters({ ...filters, orderstatus: updated });
  };



  const handleApply = () => {
    resetPage?.();
    fetchOrders();
  };

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Button size="sm" leftIcon={<FaFilter />} variant="outline" colorScheme="gray">
          Filters
        </Button>
      </PopoverTrigger>
      <PopoverContent p={4} maxW="320px" borderRadius="md" shadow="lg">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader fontWeight="bold" fontSize="md" pb={2}>
          Filter Options
        </PopoverHeader>
        <PopoverBody>
          <VStack align="start" spacing={5}>
            <Box w="full">
              <Text fontSize="sm" fontWeight="semibold" mb={2}>
                Status
              </Text>
              <Wrap spacing={3}>
                {["done", "in-progress", "cancel"].map((status) => (
                  <Checkbox
                    size="sm"
                    key={status}
                    isChecked={filters.orderstatus?.includes(status)}
                    onChange={() => handleStatusChange(status)}
                  >
                    {status}
                  </Checkbox>
                ))}
              </Wrap>
            </Box>

            <HStack pt={2} w="full" justify="space-between">
              <Button
                variant="ghost"
                size="sm"
                colorScheme="gray"
                onClick={() => setFilters({ orderstatus: [], payment: "" })}
              >
                Clear
              </Button>
              <Button colorScheme="blue" size="sm" onClick={handleApply}>
                Apply
              </Button>
            </HStack>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
